var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddressCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15.556,
    viewBox: "0 0 20 15.556",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "address-card",
    d: "M17.778,33.111a1.11,1.11,0,0,1,1.111,1.111V45.333a1.11,1.11,0,0,1-1.111,1.111H2.222a1.11,1.11,0,0,1-1.111-1.111V34.222a1.11,1.11,0,0,1,1.111-1.111ZM2.222,32A2.224,2.224,0,0,0,0,34.222V45.333a2.224,2.224,0,0,0,2.222,2.222H17.778A2.224,2.224,0,0,0,20,45.333V34.222A2.224,2.224,0,0,0,17.778,32Zm3.333,5.556a1.111,1.111,0,1,1,1.111,1.111A1.111,1.111,0,0,1,5.556,37.556Zm3.333,0a2.222,2.222,0,1,0-2.222,2.222A2.222,2.222,0,0,0,8.889,37.556Zm-5,6.111A1.667,1.667,0,0,1,5.556,42H7.778a1.667,1.667,0,0,1,1.667,1.667.556.556,0,1,0,1.111,0,2.777,2.777,0,0,0-2.778-2.778H5.556a2.777,2.777,0,0,0-2.778,2.778.556.556,0,1,0,1.111,0Zm8.333-7.222a.556.556,0,1,0,0,1.111h4.444a.556.556,0,1,0,0-1.111Zm0,2.222a.556.556,0,1,0,0,1.111h4.444a.556.556,0,1,0,0-1.111Zm0,2.222a.556.556,0,1,0,0,1.111h4.444a.556.556,0,1,0,0-1.111Z",
    transform: "translate(0 -32)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddressCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/address-card.1033934b85018228c504430296e79750.svg";